import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useQueryClient } from '@tanstack/react-query';
import { useApiQuery } from '../../../../../api/hooks';
import { SUBMISSION_FILTERS } from './ttUtils';
import SubmissionCard from './SubmissionCard';

// Панель «Управление»: очередь сдач по статусу (дефолт PENDING) + вердикты.
export default function ManagePanel({ smenaId, tasks }) {
    const queryClient = useQueryClient();
    const [filter, setFilter] = useState('PENDING');

    const { data: submissions = [], isLoading } = useApiQuery(
        ['teamtask', 'submissions', smenaId, filter],
        `/api/team-tasks/admin/submissions?status=${filter}`,
        { refetchOnMount: 'always' }
    );
    const { data: teams = [] } = useApiQuery(
        ['teams-by-smena', smenaId],
        `/api/camps/public/teams/by-smena?smenaId=${smenaId}`,
        { enabled: !!smenaId }
    );
    // Участники Соседа — для имени/аватара отправителя (сдаёт студент, обычно он игрок Соседа).
    const { data: participants = [] } = useApiQuery(
        ['neighbor', 'participants', smenaId],
        `/api/neighbor/admin/participants/list-confirmed?smenaId=${smenaId}`,
        { enabled: !!smenaId }
    );

    const teamsById = useMemo(() => {
        const map = {};
        teams.forEach(t => { map[t.id] = t; });
        return map;
    }, [teams]);

    const participantsByUserId = useMemo(() => {
        const map = {};
        participants.forEach(p => { map[p.userId] = p; });
        return map;
    }, [participants]);

    const tasksById = useMemo(() => {
        const map = {};
        tasks.forEach(t => { map[t.id] = t; });
        return map;
    }, [tasks]);

    // После вердикта обновляем все очереди (PENDING/APPROVED/REJECTED) и счётчик в шапке.
    const onChanged = () => queryClient.invalidateQueries({ queryKey: ['teamtask', 'submissions', smenaId] });

    const sorted = [...submissions].sort((a, b) => String(a.createdAt || '').localeCompare(String(b.createdAt || '')));

    return (
        <div className="bt-panel">
            <div className="tt-filters">
                {SUBMISSION_FILTERS.map(f => (
                    <button
                        type="button"
                        key={f.value}
                        className={`tt-filter${filter === f.value ? ' on' : ''}`}
                        onClick={() => setFilter(f.value)}
                    >
                        {f.label}
                    </button>
                ))}
            </div>

            {isLoading && <div className="vp-empty">Загрузка…</div>}
            {!isLoading && sorted.length === 0 && (
                <div className="bt-empty">
                    {filter === 'PENDING' ? 'Очередь пуста — новых сдач нет' : 'Нет сдач с таким статусом'}
                </div>
            )}
            {!isLoading && sorted.length > 0 && (
                <div className="tt-subs">
                    {sorted.map(sub => (
                        <SubmissionCard
                            key={sub.id}
                            submission={sub}
                            task={tasksById[sub.taskId]}
                            team={teamsById[sub.teamId]}
                            submitter={participantsByUserId[sub.submittedByUserId]}
                            onChanged={onChanged}
                        />
                    ))}
                </div>
            )}
        </div>
    );
}

ManagePanel.propTypes = {
    smenaId: PropTypes.number.isRequired,
    tasks: PropTypes.array.isRequired
};
